import React from 'react';
import { QrWrapper, QrBox } from './styles';
import { QrProps } from '../interface';
import QRCode from 'react-qr-code';
import { CLOSE_NEW_ICON } from '@Images';

const ReferQrCode: React.FC<QrProps> = ({ onClose, labels, url }): React.ReactElement => {
  const qrData = labels?.referQRCodeModalText;
  return (
    <QrWrapper>
      <QrBox>
        <div className="qrHeader">
          <div className="crossButtonContainer">
            <button className="crossButton" onClick={() => onClose(false)}>
              <img src={CLOSE_NEW_ICON} alt="close" />
            </button>
          </div>
          <div className="qrText">
            <p className="qrheadingText">{qrData?.heading}</p>
            <p className="qrDescreptionText">{qrData?.description}</p>
          </div>
        </div>
        <QRCode size={201} value={url} />
      </QrBox>
    </QrWrapper>
  );
};

export default ReferQrCode;
